import { render } from "./DemoConfirmationDialog.vue?vue&type=template&id=3e7ba248&scoped=true"
import script from "./DemoConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DemoConfirmationDialog.vue?vue&type=script&lang=js"

import "./DemoConfirmationDialog.vue?vue&type=style&index=0&id=3e7ba248&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7ba248"]])

export default __exports__